import React from 'react';
import AccordionItem from './AccordionItem';

const Accordion = ({ item, surveyLanguage }) => {
  const { items = [] } = item;

  return (
    <div>
      {items.map((accordionItem) => (
        <AccordionItem
          key={accordionItem.id}
          id={accordionItem.id}
          title={accordionItem.title}
          body={accordionItem.body}
          surveyLanguage={surveyLanguage}
        />
      ))}
    </div>
  );
};

export default Accordion;
